import DigiobcanApi from '../../../../api/DigiobcanApi';
import ConfirmationDialog from '../../../../components/ConfirmationDialog';
import { useM } from '../../../../lib/query';
import { useLogger } from '../../../../providers/LoggerProvider';
import { __, toastError, toastSuccess } from '../../../../utils';
import React from 'react';

type Props = {
  categoryId: string;
  open: boolean;
  onClose: () => void;
  selectedIds: string[];
  onSuccess: (deletedUserIds: string[]) => void;
};

const DeleteCategoryUserDialog: React.FC<Props> = ({
  categoryId,
  open,
  onClose,
  selectedIds,
  onSuccess,
}) => {
  const { logger } = useLogger();

  const deleteReportCategoryUserMutation = useM(
    (userIds: string[]) => {
      return Promise.all(
        userIds.map((userId) => {
          return DigiobcanApi.deleteReportCategoryUser(categoryId, userId);
        }),
      );
    },
    {
      onSuccess: (res, userIds) => {
        toastSuccess(
          __(
            `Kategória ${res[0]?.name} bola odstranená ${userIds.length} používateľom`,
          ),
        );

        onSuccess(userIds);
      },
      onError: (e, variables) => {
        logger.error('Error deleting category users', {
          action: 'deleteUserFromCategory',
          error: e,
          data: {
            categoryId,
            userIds: variables,
          },
        });
        toastError(__('Niečo sa pokazilo'));
      },
    },
  );

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      title={__('Odstránenie používateľov')}
      description={`${__('Naozaj si prajete odstrániť')} ${selectedIds.length} ${selectedIds.length === 1 ? __('vybraného používateľa?') : __('vybraných používateľov?')}`}
      confirmLabel={__('Zmazať')}
      onConfirm={async () => {
        if (!navigator.onLine) {
          toastError(__('Internetové pripojenie zlyhalo.'));
          return;
        }
        try {
          await deleteReportCategoryUserMutation.mutateAsync(selectedIds);
        } catch {
          // Empty catch because mutation handles errors
        }
        onClose();
      }}
      isLoading={deleteReportCategoryUserMutation.isPending}
    />
  );
};

export default DeleteCategoryUserDialog;
